"use client";

import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Shareholderpullquote() {
  const testimonials = [{
    quote: "The ROSF transaction was complex, requiring a deep understanding of both the operational nuances and the strategic landscape. BPV's guidance was instrumental in navigating the process and achieving an outcome that exceeded our expectations.",
    author: "Pat Filippelli",
    position: "Partner, Thornhill Capital"
  }, {
    quote: "BPV's expertise in deal structure and their tenacious approach to negotiations ensured that we not only found the right buyer but secured terms that truly reflected the value of the brand we built over decades.",
    author: "Steve Phillips",
    position: "CEO, Phillips Foods"
  }, {
    quote: "Finding the optimal partner and the right financing structure was critical for our next phase of growth. BPV delivered on both fronts, providing sophisticated advisory that felt like having an in-house M&A team.",
    author: "Jeff Posner",
    position: "CEO, Wholesome Goodness"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  useEffect(() => {
    const interval = setInterval(() => {
      handleChange((activeIndex + 1) % testimonials.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [activeIndex]);
  const handleChange = (index: number) => {
    if (index === activeIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveIndex(index);
      setIsTransitioning(false);
    }, 300);
  };
  const current = testimonials[activeIndex];
  const quoteWords = current.quote.split(" ");
  return <section data-section-id="3776" id="shareholderpullquote" className="bg-background text-foreground py-32 md:py-48 px-6">
      <div ref={ref} className="mx-auto max-w-[720px] flex flex-col items-center text-center">
        {}
        <div className={`mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default tracking-[0.3em] uppercase text-chart-2 !text-base !font-bold">
            C <span className="mx-2">◦</span> Client Perspectives
          </span>
        </div>

        {}
        <div className={`relative mb-8 transition-all duration-1000 delay-200 ${isVisible ? "opacity-60 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Quote className="w-24 h-24 md:w-32 md:h-32 italic text-primary" strokeWidth={1} fill="currentColor" />
        </div>

        {}
        <div className={`min-h-[200px] md:min-h-[240px] flex items-center justify-center transition-opacity duration-300 ${isTransitioning ? "opacity-0" : "opacity-100"}`}>
          <p className="font-default italic text-2xl md:text-3xl lg:text-[2rem] text-foreground" style={{
          lineHeight: "1.4"
        }}>
            {quoteWords.map((word, i) => <span key={`${activeIndex}-${i}`} data-index={i} className="inline-block" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(12px)",
            transition: `opacity 600ms ease-out ${i * 60 + 400}ms, transform 600ms ease-out ${i * 60 + 400}ms`
          }}>
                {word}&nbsp;
              </span>)}
          </p>
        </div>

        {}
        <div className={`my-10 h-px w-10 transition-all duration-1000 delay-500 bg-primary ${isVisible ? "opacity-30 scale-x-100" : "opacity-0 scale-x-0"}`} />

        {}
        <div className={`transition-opacity duration-300 ${isTransitioning ? "opacity-0" : "opacity-100"}`}>
          <span className="font-default tracking-[0.3em] uppercase text-chart-2 !text-lg">
            {current.author} <span className="mx-2">◦</span> {current.position}
          </span>
        </div>

        {}
        <div className="flex items-center gap-4 mt-20">
          {testimonials.map((_, i) => {
          const isActive = i === activeIndex;
          return <button key={i} data-index={i} onClick={() => handleChange(i)} aria-label={`View testimonial ${i + 1}`} className="relative w-3 h-3 flex items-center justify-center transition-all duration-300">
                <span className={`block rounded-lg transition-all duration-300 ${isActive ? "w-2.5 h-2.5 bg-primary" : "w-2 h-2 border border-chart-2"}`} />
                {isActive && <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill="none" stroke="var(--primary)" strokeWidth="1" strokeOpacity="0.3" />
                    <circle cx="12" cy="12" r="10" fill="none" stroke="var(--primary)" strokeWidth="1" strokeDasharray="62.83" strokeDashoffset="62.83" style={{
                animation: "voicesProgressArc 8s linear infinite"
              }} />
                  </svg>}
              </button>;
        })}
        </div>

        <style>{`
          @keyframes voicesProgressArc {
            from {
              stroke-dashoffset: 62.83;
            }
            to {
              stroke-dashoffset: 0;
            }
          }
        `}</style>
      </div>
    </section>;
}